import { Grid, Tooltip} from "@mui/material";

export function getRmvendorquotationStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        rawdemandid:{
            name:'rawdemandid',
            label:'Raw Demand Id',
            value:'',
            error:false,
            errorMessage:'You must enter Raw Demand Id',
            required:true,
            fieldtype:'ID'
        },
        quotation:{
            name:'quotation',
            label:'Quotation',
            value:'',
            error:false,
            errorMessage:'You must enter Quotation',
            required:true,
            fieldtype:'double'
        },
        rmvendorid:{
            name:'rmvendorid',
            label:'rmvendor Id',
            value:'',
            error:false,
            errorMessage:'You must enter rmvendor Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        rmvendorname:{
            name:'rmvendorname',
            label:'rmvendor Name',
            value:'',
            error:false,
            errorMessage:'You must enter rmvendor Name',
            required:true,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'rawdemandid', headerName: 'Raw Demand Id', width:150 },
        { field: 'quotation', headerName: 'Quotation', width:150 },
        { field: 'rmvendorid', headerName: 'rmvendor Id', width:150 },
        { field: 'rmvendorname', headerName: 'rmvendor Name', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['rawdemandid']:{
          ...formValues['rawdemandid'],
          value:data.rawdemandid,
        },['quotation']:{
          ...formValues['quotation'],
          value:data.quotation,
        },['rmvendorid']:{
          ...formValues['rmvendorid'],
          value:data.rmvendorid,
        },['rmvendorname']:{
          ...formValues['rmvendorname'],
          value:data.rmvendorname,
        },
      })
}